import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Button, Icon, Tooltip } from 'antd';

const styles = theme => ({
  bulkInquiryError: {
    marginTop: '5px',
    display: 'flex',
    alignItems: 'center',
  },
  downloadIcon: {
    fontSize: '20px',
    cursor: 'pointer',
    color: theme.colors.text,
    marginLeft: '20px',
  },
  errorsIcon: {
    marginRight: '5px',
    color: theme.colors.error,
    fontSize: '20px',
    verticalAlign: 'middle',
  },
});

class FailureArrayHandlerInquiry extends React.PureComponent<any, any> {

  render() {
    const { classes, failureData, isVisible, okText, onModalClose, successMessage } = this.props;
    return (
      <Modal title="Errors" visible={isVisible}
        okText="Ok"
        destroyOnClose
        onCancel={onModalClose}
        footer={<Button type="primary" onClick={onModalClose}>
          {okText ? okText : 'Okay'}
        </Button>}>
        {failureData && <div>
            <Icon type="exclamation-circle" theme="filled"
              className={classes.errorsIcon} style={{ color: '#52C41A' }} />
              {`${failureData.successCount} ${successMessage ? successMessage : 'Successful'}`}
            <div  className={classes.bulkInquiryError}>
              <Icon type="exclamation-circle" theme="filled" className={classes.errorsIcon} />
                {`${failureData.failureCount} Error(s)`}
              <Tooltip title="Download Errors" placement="right">
                <a href={failureData.failureFileLink} target="_blank">
                  <Icon type="download" className={classes.downloadIcon} />
                </a>
              </Tooltip>
            </div>
        </div>}
      </Modal>
    );
  }
}

const StyledComp = injectSheet(styles)(FailureArrayHandlerInquiry);
export default StyledComp;
